<template>
  <div id="modalCreateEditEvento" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-full">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ textModal }} Evento</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div class="modal-body">
            <!-- Dados do Evento -->
            <div class="card card-body border border-width-2 border-teal">
              <div class="row g-3">
                <div class="col-md-6">
                  <label class="form-label">
                    Demandante (Gestor): <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    :class="{
                      'is-invalid': v$.evento.codDemandante.$errors.length,
                    }"
                    v-model="v$.evento.codDemandante.$model"
                    @change="onChangeDemandante"
                  >
                    <option value="" disabled>Selecione uma opção</option>
                    <option
                      v-for="demandante in demandantes"
                      :key="demandante.codUsuario"
                      :value="demandante.codUsuario"
                    >
                      {{ demandante.nomeUsuario }}
                    </option>
                  </select>
                  <span
                    v-if="v$.evento.codDemandante.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-6">
                  <label class="form-label">
                    Entidade Demandante: <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{
                      'is-invalid': v$.evento.entidadeDemandante.$errors.length,
                    }"
                    placeholder="Entidade demandante"
                    v-model="v$.evento.entidadeDemandante.$model"
                  />
                  <span
                    v-if="v$.evento.entidadeDemandante.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-12">
                  <label class="form-label">
                    Nome do evento, patrocínio ou projeto:
                    <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    :class="{
                      'is-invalid': v$.evento.eventoNomeId.$errors.length,
                    }"
                    v-model="v$.evento.eventoNomeId.$model"
                  >
                    <option value="" disabled>Selecione uma opção</option>
                    <option
                      v-for="nomeEvento in nomesEventos"
                      :key="nomeEvento.id"
                      :value="nomeEvento.id"
                    >
                      {{ nomeEvento.nome }}
                    </option>
                  </select>
                  <span
                    v-if="v$.evento.eventoNomeId.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-2">
                  <label class="form-label">
                    Data Inicial: <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    :class="{
                      'is-invalid': v$.evento.dataInicial.$errors.length,
                    }"
                    v-model="v$.evento.dataInicial.$model"
                  />
                  <span
                    v-if="v$.evento.dataInicial.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                  <span
                    v-if="v$.evento.dataInicial.lessThanFinal.$invalid"
                    class="invalid-feedback"
                  >
                    Deve ser menor ou igual a data final
                  </span>
                </div>
                <div class="col-md-2">
                  <label class="form-label">
                    Data Final: <span class="text-danger">*</span>
                  </label>
                  <input
                    type="date"
                    class="form-control"
                    :class="{
                      'is-invalid': v$.evento.dataFinal.$errors.length,
                    }"
                    v-model="v$.evento.dataFinal.$model"
                  />
                  <span
                    v-if="v$.evento.dataFinal.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                  <span
                    v-if="v$.evento.dataFinal.greaterThanInicial.$invalid"
                    class="invalid-feedback"
                  >
                    Deve ser igual ou maior que a data inicial
                  </span>
                </div>
                <div class="col-md-2">
                  <label class="form-label">
                    Estado: <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': v$.evento.estado.$errors.length }"
                    v-model="v$.evento.estado.$model"
                    @change="onChangeEstado"
                  >
                    <option value="" disabled>Selecione</option>
                    <option
                      v-for="estado in estados"
                      :key="estado.sigla"
                      :value="estado.sigla"
                    >
                      {{ estado.nome }}
                    </option>
                  </select>
                  <span
                    v-if="v$.evento.estado.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-6">
                  <label class="form-label">
                    Cidade: <span class="text-danger">*</span>
                  </label>
                  <select
                    class="form-control"
                    :class="{ 'is-invalid': v$.evento.cidade.$errors.length }"
                    v-model="v$.evento.cidade.$model"
                    :disabled="!evento.estado || loadingCidades"
                  >
                    <option value="" disabled>
                      {{
                        loadingCidades
                          ? 'Carregando...'
                          : 'Selecione uma cidade'
                      }}
                    </option>
                    <option
                      v-for="cidade in cidades"
                      :key="cidade.id"
                      :value="cidade.nome"
                    >
                      {{ cidade.nome }}
                    </option>
                  </select>
                  <span
                    v-if="v$.evento.cidade.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-9">
                  <label class="form-label">
                    Local de realização: <span class="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    :class="{ 'is-invalid': v$.evento.local.$errors.length }"
                    placeholder="Local de realização do evento"
                    v-model="v$.evento.local.$model"
                  />
                  <span
                    v-if="v$.evento.local.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-md-3">
                  <label class="form-label">
                    Público: <span class="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    :class="{ 'is-invalid': v$.evento.publico.$errors.length }"
                    placeholder="Público estimado"
                    min="1"
                    v-model="v$.evento.publico.$model"
                  />
                  <span
                    v-if="v$.evento.publico.required.$invalid"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório
                  </span>
                </div>
                <div class="col-sm-9">
                  <label class="form-label">Observações:</label>
                  <textarea
                    class="form-control"
                    placeholder="Observações gerais"
                    rows="1"
                    v-model="evento.observacao"
                  />
                </div>
                <div class="col-md-3">
                  <label class="form-label">
                    Custo Total do Evento: <span class="text-danger">*</span>
                  </label>
                  <div class="input-group">
                    <span class="input-group-text">R$</span>
                    <input
                      type="text"
                      class="form-control text-end"
                      :value="custoTotalFormatado"
                      disabled
                    />
                    <span class="input-group-text">,00</span>
                  </div>
                </div>
                <p v-if="evento.id" class="mb-0">
                  <span>
                    {{
                      createdUpdatedUser(
                        evento.usuarioCriacao,
                        evento.dataCriacao,
                        'created',
                      )
                    }}
                  </span>
                  <span v-if="evento.usuarioAlteracao" class="px-1">|</span>
                  <span v-if="evento.usuarioAlteracao">
                    {{
                      createdUpdatedUser(
                        evento.usuarioAlteracao,
                        evento.dataAlteracao,
                        'updated',
                      )
                    }}
                  </span>
                </p>
              </div>
            </div>
            <!-- Dados das Entidades -->
            <div class="mb-3">
              <p>
                Entidades:
                <span
                  role="button"
                  class="badge bg-success text-black ms-1"
                  title="Adicionar Entidade"
                  @click="addEntidade"
                >
                  <i class="ph-plus" /> Adicionar Entidade
                </span>
              </p>
            </div>
            <div
              class="card border border-width-2 border-teal"
              v-for="(entidade, index) in evento.entidades"
              :key="index"
            >
              <div class="card-header d-flex align-items-center p-2">
                <p class="mb-0">
                  Status:
                  <span
                    v-html="statusEventosTranslate(entidade.status, 'label')"
                  />
                </p>
                <span
                  v-if="entidade.principal == entidadesEventos.PRINCIPAL"
                  class="badge bg-primary ms-1"
                >
                  Principal
                </span>
                <div class="ms-auto">
                  <button
                    v-if="
                      entidade.principal == entidadesEventos.PARCEIRA &&
                      entidade.status == statusEventos.AGUARDANDO_APROVACAO
                    "
                    type="button"
                    class="btn btn-sm btn-outline-danger btn-icon"
                    title="Remover Entidade"
                    @click="removeEntidade(index)"
                  >
                    <i class="ph-trash"></i>
                  </button>
                </div>
              </div>
              <div class="card-body">
                <div class="row g-2">
                  <div class="col-md-4">
                    <label class="form-label">
                      Nome: <span class="text-danger">*</span>
                    </label>
                    <select
                      class="form-control"
                      :value="
                        'outroNome' in entidade ? 'OUTRO' : entidade.codColigada
                      "
                      :disabled="
                        entidade.principal == entidadesEventos.PRINCIPAL &&
                        entidade.status != statusEventos.AGUARDANDO_APROVACAO
                      "
                      @change="onChangeEntidade(index, $event.target.value)"
                    >
                      <option value="">Selecione uma opção</option>
                      <option
                        v-for="empresa in empresasDisponiveis(index)"
                        :key="empresa.codColigada"
                        :value="empresa.codColigada"
                      >
                        {{ empresa.nome }}
                      </option>
                      <option value="OUTRO">OUTRO</option>
                    </select>
                  </div>
                  <div v-if="'outroNome' in entidade" class="col-md-4">
                    <label class="form-label">
                      Nome do parceiro: <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Nome do parceiro"
                      v-model="entidade.outroNome"
                      @input="evento.entidades[index].nome = entidade.outroNome"
                      :disabled="
                        entidade.status != statusEventos.AGUARDANDO_APROVACAO
                      "
                    />
                  </div>
                  <div v-if="!('outroNome' in entidade)" class="col-md-4">
                    <label class="form-label">
                      Centro de Custo (Agrupador):
                    </label>
                    <select
                      class="form-control"
                      v-model="entidade.codCCustoPai"
                      :disabled="
                        entidade.status != statusEventos.AGUARDANDO_APROVACAO
                      "
                    >
                      <option value="">Selecione uma opção</option>
                      <option
                        v-for="cc in centrosCustoDisponiveis(index)"
                        :key="cc.codCCustoPai"
                        :value="cc.codCCustoPai"
                      >
                        {{ cc.codCCustoPai }} - {{ cc.nomeCCustoPai }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-4">
                    <label class="form-label">
                      Custo Total: <span class="text-danger">*</span>
                    </label>
                    <div class="input-group">
                      <span class="input-group-text">R$</span>
                      <input
                        type="text"
                        class="form-control text-end"
                        placeholder="Custo Total"
                        v-model="v$.evento.entidades.$model[index].custo"
                        v-maska="'#*'"
                        :disabled="
                          entidade.status != statusEventos.AGUARDANDO_APROVACAO
                        "
                      />
                      <span class="input-group-text">,00</span>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <label class="form-label">Observações:</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Observações"
                      v-model="entidade.observacao"
                      :disabled="
                        entidade.status != statusEventos.AGUARDANDO_APROVACAO
                      "
                    />
                  </div>
                  <p v-if="entidade.id" class="mb-0">
                    <span>
                      {{
                        createdUpdatedUser(
                          entidade.usuarioCriacao,
                          entidade.dataCriacao,
                          'created',
                        )
                      }}
                    </span>
                    <span v-if="entidade.usuarioAlteracao" class="px-1">|</span>
                    <span v-if="entidade.usuarioAlteracao">
                      {{
                        createdUpdatedUser(
                          entidade.usuarioAlteracao,
                          entidade.dataAlteracao,
                          'updated',
                        )
                      }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="fw-bold text-end">
              Custo Total do Evento: R$ {{ custoTotalFormatado }},00
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button
              type="button"
              class="btn btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-success"
              :title="textModal"
              :disabled="v$.$invalid || disableButton"
            >
              <span v-if="disableButton">
                <i class="ph-spinner spinner" />
              </span>
              <span v-else>{{ textModal }}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { useVuelidate } from '@vuelidate/core'
import { required, numeric, helpers } from '@vuelidate/validators'
import { maska } from 'maska'
import { showModal, hideModal } from '@/utils/modal'
import { createdUpdatedUser, statusEventosTranslate } from '@/utils/strings'
import EntidadeEventoEnum from '@/enum/entidadeEventoEnum'
import StatusEventoEnum from '@/enum/statusEventoEnum'

export default {
  name: 'CreateEditEventoModal',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    eventoId: {
      type: String,
      default: null,
    },
  },

  setup() {
    return { v$: useVuelidate() }
  },

  directives: { maska },

  data() {
    return {
      nomesEventos: [],
      empresas: [],
      demandantes: [],
      estados: [],
      cidades: [],
      evento: {
        eventoPeriodoId: this.filters.eventoPeriodoId,
        eventoNomeId: '',
        periodo: this.filters.periodo,
        codDemandante: '',
        demandante: '',
        entidadeDemandante: '',
        dataInicial: '',
        dataFinal: '',
        estado: '',
        cidade: '',
        local: '',
        publico: '',
        custoTotal: 0,
        observacao: '',
        status: 0,
        entidades: [
          {
            codColigada: null,
            nome: '',
            principal: 1,
            codCCustoPai: '',
            custo: '',
            observacao: '',
            status: 0,
          },
        ],
        entidadesDelete: [],
      },
      loadingCidades: false,
      disableButton: false,
      createdUpdatedUser,
      statusEventosTranslate,
    }
  },

  computed: {
    ...mapGetters(['user']),

    textModal() {
      return this.eventoId ? 'Atualizar' : 'Cadastrar'
    },

    custoTotal() {
      return this.evento.entidades.reduce((acc, e) => {
        return acc + (parseInt(e.custo, 10) || 0)
      }, 0)
    },

    custoTotalFormatado() {
      return this.custoTotal.toLocaleString('pt-BR')
    },

    statusEventos() {
      return StatusEventoEnum
    },

    entidadesEventos() {
      return EntidadeEventoEnum
    },
  },

  methods: {
    initData() {
      this.evento.status = this.statusEventos.AGUARDANDO_APROVACAO
      this.evento.entidades[0].codColigada = this.user.codColigada
      this.evento.entidades[0].nome = this.user.nomeColigada
      this.evento.entidades[0].principal = this.entidadesEventos.PRINCIPAL
      this.evento.entidades[0].status = this.statusEventos.AGUARDANDO_APROVACAO

      this.getDemandantes()
      this.getNomesEventos()
      this.getEmpresas()
      this.getEstados()

      if (this.eventoId) {
        this.getEvento()
      } else {
        showModal('modalCreateEditEvento')
      }
    },

    async getDemandantes() {
      try {
        this.demandantes = await this.$store.dispatch('getUsuariosGestores')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getNomesEventos() {
      try {
        this.nomesEventos = await this.$store.dispatch('getNomesEventos')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getEmpresas() {
      try {
        this.empresas = await this.$store.dispatch('getEmpresas', {
          cCustoPai: true,
        })
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async getEstados() {
      try {
        const response = await fetch(
          'https://servicodados.ibge.gov.br/api/v1/localidades/estados',
        )
        this.estados = await response.json()
        this.estados.sort((a, b) => a.nome.localeCompare(b.nome))
      } catch (error) {
        this.$root.$refs.notification.error(
          'Não foi possível carregar os estados.',
        )
      }
    },

    async getCidades() {
      this.cidades = []

      if (!this.evento.estado) {
        this.evento.cidade = ''
        return
      }

      this.loadingCidades = true
      try {
        const response = await fetch(
          `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.evento.estado}/municipios`,
        )

        this.cidades = await response.json()
        this.cidades.sort((a, b) => a.nome.localeCompare(b.nome))
      } catch (error) {
        this.$root.$refs.notification.error(
          'Não foi possível carregar as cidades.',
        )
      } finally {
        this.loadingCidades = false
      }
    },

    async getEvento() {
      try {
        this.evento = await this.$store.dispatch('getEvento', this.eventoId)

        this.evento.entidades = this.evento.entidades.map((entidade) => {
          if (!entidade.codColigada) {
            return { ...entidade, outroNome: entidade.nome }
          }
          return entidade
        })

        this.evento.entidadesDelete = []

        if (this.evento.estado) {
          await this.getCidades()
        }

        showModal('modalCreateEditEvento')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    onChangeDemandante() {
      const demandante = this.demandantes.find(
        (d) => d.codUsuario === this.evento.codDemandante,
      )
      this.evento.demandante = demandante?.nomeUsuario ?? ''
    },

    async onChangeEstado() {
      this.evento.cidade = ''
      await this.getCidades()
    },

    empresasDisponiveis(indexAtual) {
      const coligadasUsadas = this.evento.entidades
        .filter((_, i) => i !== indexAtual)
        .map((e) => Number(e.codColigada))

      return this.empresas.filter(
        (emp) => !coligadasUsadas.includes(Number(emp.codColigada)),
      )
    },

    centrosCustoDisponiveis(index) {
      const entidade = this.evento.entidades[index]

      if ('outroNome' in entidade) {
        const empresaPrincipal = this.empresas.find(
          (e) => Number(e.codColigada) === Number(this.user.codColigada),
        )
        return empresaPrincipal ? empresaPrincipal.ccCustos : []
      }

      if (entidade.codColigada) {
        const empresa = this.empresas.find(
          (e) => Number(e.codColigada) === Number(entidade.codColigada),
        )
        return empresa ? empresa.ccCustos : []
      }

      return []
    },

    onChangeEntidade(index, valor) {
      const entidade = this.evento.entidades[index]

      if (valor === 'OUTRO') {
        this.evento.entidades[index] = {
          ...entidade,
          codColigada: null,
          nome: '',
          outroNome: '',
          codCCustoPai: '',
        }
      } else if (!valor) {
        const { outroNome, ...resto } = entidade

        this.evento.entidades[index] = {
          ...resto,
          codColigada: null,
          nome: '',
          codCCustoPai: '',
        }
      } else {
        const { outroNome, ...resto } = entidade

        const empresa = this.empresas.find(
          (e) => Number(e.codColigada) === Number(valor),
        )

        this.evento.entidades[index] = {
          ...resto,
          codColigada: Number(valor),
          nome: empresa ? empresa.nome : '',
          codCCustoPai: '',
        }
      }
    },

    addEntidade() {
      this.evento.entidades.push({
        codColigada: null,
        nome: '',
        principal: this.entidadesEventos.PARCEIRA,
        codCCustoPai: '',
        custo: '',
        observacao: '',
        status: this.statusEventos.AGUARDANDO_APROVACAO,
      })
    },

    removeEntidade(index) {
      const entidade = this.evento.entidades[index]

      if (entidade.id) {
        this.evento.entidadesDelete.push(entidade.id)
      }

      this.evento.entidades.splice(index, 1)
    },

    async save() {
      if (!this.v$.$invalid) {
        this.disableButton = true
        try {
          this.evento.custoTotal = this.custoTotal

          let response = null
          if (this.eventoId) {
            response = await this.$store.dispatch('updateEvento', {
              eventoId: this.eventoId,
              evento: this.evento,
            })
          } else {
            response = await this.$store.dispatch('saveEvento', this.evento)
          }

          hideModal()
          this.$emit('closeModal', true)
          this.$root.$refs.notification.success(response.message)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$refs.notification.warning(error.message)
          } else {
            this.$root.$refs.notification.error(
              'Não foi possível se conectar ao servidor.',
            )
          }
        }
      }
    },
  },

  validations() {
    return {
      evento: {
        codDemandante: {
          required,
        },
        demandante: {
          required,
        },
        entidadeDemandante: {
          required,
        },
        eventoNomeId: {
          required,
        },
        dataInicial: {
          required,
          lessThanFinal: (v) =>
            !this.evento.dataFinal || v <= this.evento.dataFinal,
        },
        dataFinal: {
          required,
          greaterThanInicial: (v) =>
            !this.evento.dataInicial || v >= this.evento.dataInicial,
        },
        estado: {
          required,
        },
        cidade: {
          required,
        },
        local: {
          required,
        },
        publico: {
          required,
          numeric,
        },
        custoTotal: {
          required,
          numeric,
        },
        entidades: {
          $each: helpers.forEach({
            nome: { required },
            custo: { required },
          }),
        },
      },
    }
  },

  mounted() {
    this.initData()
  },
}
</script>
